<template>
  <div class="main">
    <div class="detail">
      <ListTable
        :catid="catid"
        @getdetails="getdetails"
        ref="table"
      ></ListTable>
    </div>
    <div>
      <Preview
        :catesingle="catesingle"
        :articleId="articleId"
        :articleVis="articleVis"
        :catid="catid"
        @close="close"
        @reset="reset"
      ></Preview>
    </div>
  </div>
</template>

<script>
import ListTable from './ListTable';
import Preview from './preview';
export default {
  name: 'Lists',
  components: { ListTable, Preview },
  data() {
    return {
      searchValue: '',
      oldtreeData: [],
      tempObj: [],
      expandedKeys: [],
      treeData: [],
      autoExpandParent: true,
      valueTree: undefined,
      catid: 0,
      catesingle: [],
      articleId: 0,
      articleVis: false
    };
  },
  created() {},
  mounted() {
    this.catid = 331979;
  },
  methods: {
    getdetails(id) {
      this.articleVis = true;
      this.articleId = id;
    },
    close() {
      this.articleVis = false;
    },
    reset() {
      this.$refs.table.getLists();
    }
  }
};
</script>

<style scoped>
.wrap {
  position: relative;
}
.caret {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 6px dashed;
  border-right: 6px dashed;
  border-bottom: 6px solid transparent;
  border-left: 6px solid transparent;
}
.primary {
  border-top-color: #1890ff;
  border-right-color: #1890ff;
}
.gray {
  border-top-color: #d9d9d9;
  border-right-color: #d9d9d9;
}
.main {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.lists {
  width: 360px;
  position: absolute;
  padding: 0 10px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
}
.row {
  padding: 5px;
  min-height: 80px;
  line-height: 24px;
  border-bottom: 1px solid #e8e8e8;
}
.current {
  background-color: #409eff;
}

.active,
.active > .pubtime,
.active > .user {
  color: #fff;
}

.row .title {
  font-size: 16px;
  min-height: 50px;
}

.row .title i {
  margin-right: 5px;
}

.row .info {
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  color: #c0c4cc;
}

.row .info .pubtime {
  text-align: left;
}
.row .info .user {
  text-align: right;
}

.detail {
  position: absolute;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 10px;
  overflow-y: auto;
}
.detail .toolbar {
  text-align: right;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.detail .toolbar i {
  margin-right: 5px;
}

.detail .toolbar .menu {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 70px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.catelists {
  max-height: 300px;
  overflow: hidden;
  overflow-y: auto;
}

.cate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
  text-align: left;
  /*height: 38px;*/
  line-height: 38px;
}
.cate:hover {
  background: #eeeeee;
}

.dropdown-key {
  max-height: 600px;
  overflow: hidden;
  overflow-y: auto;
  width: 800px;
}

code {
  margin: 0 1px;
  background: #f2f4f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
  color: #7e7e7e;
  border: 1px solid #eee;
}
</style>
